import { TsDOM as q } from '@/scripts/core/TsDOM'
import { ArticleVideoFullscreen } from '@/scripts/article/article-video-fullscreen'

console.log('[js-dir-article] entry loaded')
q.safeDefineElement(ArticleVideoFullscreen)
console.log(
	'[js-dir-article] defined?',
	customElements.get('article-video-fullscreen')
)
